import { getAuth, onAuthStateChanged, User } from "firebase/auth";

export class GuardHelper{
    static async getCurrentUser(): Promise<User | null> {
        const auth = getAuth();
        if (auth.currentUser) {
          return auth.currentUser;
        }
        return new Promise<User | null>((resolve) => {
          const unsubscribe = onAuthStateChanged(auth, (user) => {
            unsubscribe();
            resolve(user);
          });
        });
      }
}



